<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    facilityId: {
      type: String,
      value: "",
    },
    createBy: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "",
      key: "id",
      url: {
        //   get: '/admin/system/inventory',
        // add: '/admin/system/inventory',
        // add: '/admin/system/inventory/receive',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "入库原因",
          name: "stockCause",
          value: "",
          type: "textarea",
          rules: [
            { required: true, message: "入库原因不能为空", trigger: "blur" },
          ],
        },
        {
          label: "入库地点",
          name: "stockSite",
          value: "",
          type: "input",
          rules: [
            { required: true, message: "入库地点不能为空", trigger: "blur" },
          ],
        },
        {
          label: "入库时间",
          name: "stockTime",
          value: "",
          type: "datetime",
          rules: [
            { required: true, message: "入库时间不能为空", trigger: "blur" },
          ],
        },
        // {
        //   label: "入库人",
        //   name: "stockBy",
        //   value: "",
        //   type: "input",
        //   rules: [{ required: true,message: "入库人不能为空" ,trigger: "blur" }],
        // },
        { label: "备注信息", name: "remark", value: "", type: "textarea" },
      ],
      forms: {
        facilityId: this.facilityId,
        state: 1,
        createBy: this.createBy,
        stockBy: $utils.data.get("auth", "username"),
      },
    };
  },
  created() {},
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/facility/change`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$emit("reset");
              }
              this.$Modal.remove();
              // setTimeout(() => {
              // $utils.url.go(0);
              // }, 2000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$emit("reset");
              this.$Modal.remove();
              // setTimeout(() => {
              // $utils.url.go(0);
              // }, 2000);
            });
        }
      });
    },
    // loadLevelData() {
    //             let q = {}
    //             $utils.api.load('consumablesClassDropList', q).then((res) => {
    //             if(res && res.data){
    //                 let ll = res.data
    //                 let dropList = []
    //                 for (let index = 0; index < ll.length; index++) {
    //                     const element = ll[index];
    //                     let xx = {}
    //                     xx.value = element.id
    //                     xx.name = element.name
    //                     dropList.push(xx)
    //                 }
    //                 for (let index = 0; index < this.items.length; index++) {
    //                     const element = this.items[index];
    //                     if(element && element.name == 'id') {
    //                         this.items[index]['dropList'] = dropList
    //                     }
    //                 }
    //             }
    //         })
    //     },
  },
};
</script>
